import { ReactNode } from "react";
import useTextStore from "../../state/TextStore";

export function getDynamicText(
  textKey: string,
  replaceComponent?: string,
): string {
  if (replaceComponent) {
    const parts = textKey.split(/\[.*?]/g);

    return `${parts[0]}${replaceComponent}${parts[1]}`;
  }

  return textKey;
}

type DynamicTextProps = {
  textKey: string;
  className?: string;
  replaceComponent?: ReactNode;
};
export default function DynamicText({
  textKey,
  replaceComponent,
  className,
}: DynamicTextProps) {
  const { getTextByKey } = useTextStore();

  if (replaceComponent) {
    const text = getTextByKey(textKey);
    const parts = text.split(/\[.*?]/g);

    return (
      <span className={className}>
        {parts[0]}
        {replaceComponent}
        {parts[1]}
      </span>
    );
  }
  return <span className={className}>{getTextByKey(textKey)}</span>;
}
